module.exports = __webpack_public_path__ + "jira-2-17ab4e2b6b5c5a04f479ff20ae40f751.webp";